import React from "react"

import {
  getBackgroundImage,
  getCorner,
  getPackageColor,
} from "../../utils/getBackgroundImage"
import screenResponsive from "../../utils/screenResponsive"

import HeroSignUpContent from "./HeroSignUpContent"
import {
  CornerImage,
  HeroContainer,
  HeroSignUpSection,
} from "./styles/HeroSignUp.styled"

const HeroType = {
  Standard: "Standard",
  Package: "Package",
}

const HeroSignUp = ({ component }) => {
  const isStandard = component?.heroType === HeroType.Standard
  const isTablet = screenResponsive(1024)
  const packageData = component?.package
  const formId = component?.hubspotFormId
  const isTalkToSales = component?.package?.title
    ?.toLowerCase()
    .includes("sales")

  const titleData = {
    color: isStandard ? component?.color : getPackageColor(packageData?.color),
    heading: isStandard ? component?.heading : packageData?.title,
    icon: isStandard ? component?.icon : packageData?.icon,
    subheading: component?.subheading,
    kicker: component?.kicker,
    supportSectionHeading: component?.supportSectionHeading,
    supportContent: component?.supportContent,
  }

  const background = getBackgroundImage(titleData.color)

  const bulletHeading = component?.bulletSectionHeading
  const iconHeading = component?.iconSectionHeading
  const textHeading = component?.textSectionHeading

  const bulletItems = component?.bulletPoints
  const iconItems = component?.iconItems
  const textItems = component?.textItems

  const data = {
    isTalkToSales,
    isStandard,
    formId,
    bulletHeading,
    iconHeading,
    textHeading,
    bulletItems,
    iconItems,
    textItems,
    ...titleData,
  }

  return (
    <HeroSignUpSection background={background}>
      {isTablet && !isStandard && (
        <CornerImage src={getCorner(titleData?.color)} />
      )}
      <HeroContainer>
        <HeroSignUpContent {...data} />
      </HeroContainer>
    </HeroSignUpSection>
  )
}

export default HeroSignUp
